// Classificação automática do perfil de engajamento do aluno a partir dos
// 4 pilares (progresso, qualidade do tempo, pontualidade, exploração) e do
// score final. Espelha a régua de tons usada na tabela de alunos
// (>=40 good · >=35 warn · <35 bad) — os scores reais concentram-se baixo,
// então os cortes do score total não seguem a escala 0-100 "escolar".

import {
  HelpCircle,
  AlertTriangle,
  Zap,
  AlarmClock,
  Compass,
  Star,
  TrendingUp,
  Activity
} from "lucide-react";

export function classificarPerfil(a) {
  const score = a.score_engajamento;
  const prog = a.eng_progresso ?? 0;
  const tempo = a.eng_qualidade ?? 0;
  const pont = a.eng_pontualidade ?? 0;
  const expl = a.eng_exploracao ?? 0;

  if (score == null) {
    return {
      titulo: "Sem dados suficientes",
      tone: "none",
      icon: HelpCircle,
      resumo:
        "Ainda não há registros de atividade suficientes para traçar o perfil deste aluno no período selecionado."
    };
  }

  if (score < 30) {
    return {
      titulo: "Risco de Evasão",
      tone: "bad",
      icon: AlertTriangle,
      resumo:
        "Engajamento crítico: pouco tempo de estudo, atividades paradas e prazos ignorados. O aluno está se desconectando da turma e precisa de intervenção imediata."
    };
  }

  if (prog >= 80 && tempo < 30) {
    return {
      titulo: "Conclusão Relâmpago",
      tone: "warn",
      icon: Zap,
      resumo:
        "Marca as atividades como concluídas em um tempo muito abaixo do da turma — avança sem de fato consumir o conteúdo. Vale conferir a qualidade dessas entregas."
    };
  }

  if (prog >= 75 && pont < 40) {
    return {
      titulo: "Entrega em Cima da Hora",
      tone: "warn",
      icon: AlarmClock,
      resumo:
        "Cumpre as atividades, mas concentra as entregas nos últimos momentos do prazo. É um sinal de rotina de estudos desorganizada, ainda que o conteúdo esteja sendo feito."
    };
  }

  if (expl >= 80 && prog < 60) {
    return {
      titulo: "Curioso Sem Foco",
      tone: "warn",
      icon: Compass,
      resumo:
        "Navega bastante pelos conteúdos livres da plataforma, mas deixa as atividades obrigatórias para trás. A curiosidade existe — falta direcioná-la para o que é cobrado."
    };
  }

  if (prog >= 75 && tempo >= 70 && pont >= 70 && expl >= 70) {
    return {
      titulo: "Aluno Destaque",
      tone: "good",
      icon: Star,
      resumo:
        "Conclui as atividades no prazo, dedica tempo de estudo compatível com a turma e ainda explora conteúdos extras por conta própria. Desempenho exemplar."
    };
  }

  if (score >= 45) {
    return {
      titulo: "Ritmo Constante",
      tone: "good",
      icon: TrendingUp,
      resumo:
        "Cumpre as atividades com regularidade e tempo de estudo dentro do esperado, sem alertas críticos. Há espaço para avançar além do obrigatório."
    };
  }

  return {
    titulo: "Presença Irregular",
    tone: "none",
    icon: Activity,
    resumo:
      "Participa de forma intermitente: entrega parte das atividades, alternando períodos ativos com pausas longas ou pouco tempo real de estudo. Merece acompanhamento próximo."
  };
}
